import _construct from "@babel/runtime-corejs3/helpers/construct";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import dayjs from 'dayjs';
export function getNowDate(isEnd) {
  // only date without time
  var now = new Date();
  isEnd ? endTime(now) : clearTime(now);
  return dayjs(now);
}
export function clearTime(date) {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
}
export function endTime(date) {
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  date.setMilliseconds(999);
}
export function isEqual(a, b, type) {
  if (type === void 0) {
    type = 'date';
  }
  if (a && b) {
    return a.isSame(b, type);
  }
  return false;
}
export function isLT(a, b, type) {
  if (type === void 0) {
    type = 'date';
  }
  if (a && b) {
    return a.isBefore(b, type);
  }
  return false;
}
export function isGT(a, b, type) {
  if (type === void 0) {
    type = 'date';
  }
  return isLT(b, a, type);
}
export function createDate(date) {
  if (typeof date === 'string') {
    var _context;
    var _date$split = date.split(' '),
      dateString = _date$split[0],
      timeString = _date$split[1];
    var args = _mapInstanceProperty(_context = dateString.split('-')).call(_context, Number);
    args[1] = args[1] - 1;
    if (timeString) {
      var _context2;
      args.push.apply(args, _mapInstanceProperty(_context2 = timeString.split(':')).call(_context2, Number));
    }
    return _construct(Date, args);
  }
  if (!date) return new Date();
  return new Date(date);
}
export function findValueIndex(values, value, type) {
  return _findIndexInstanceProperty(values).call(values, function (item) {
    if (Array.isArray(item)) {
      // is multipe range values
      var start = value[0],
        end = value[1];
      return isEqual(item[0], start, type) && isEqual(item[1], end, type);
    } else {
      return isEqual(value, item, type);
    }
  });
}
export function last(arr) {
  return arr[arr.length - 1];
}